import dayjs from 'dayjs';

abstract class FlightUtil {
  public static getFlightDuration(flightDurationInMinutes: number): string {
    const flightDurationInMinutesNumber = flightDurationInMinutes;
    let hours = Math.floor(flightDurationInMinutesNumber / 60);
    let minutes = flightDurationInMinutesNumber % 60;
    hours = hours < 10 ? hours : hours;
    minutes = minutes < 10 ? minutes : minutes;
    return `${hours}h ${minutes}min`;
  }

  public static getStopDuration = (arrivalDate: string, departureDate: string): string => {
    const diff: number = dayjs(departureDate).valueOf() - dayjs(arrivalDate).valueOf();
    return FlightUtil.getFlightDuration(diff / 1000 / 60);
  };
}

export default FlightUtil;
